'use strict';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.StyleInjectHandler = StyleInjectHandler;
var _react = require('react');
var _gemsShared = require('@tencent/gems-shared');
function iGetInjectSchema(schema) {
    return Object.entries(schema).reduce(function(maps, param1) {
        var _param = _slicedToArray(param1, 2), key = _param[0], inject = _param[1].inject;
        if (!inject) {
            return maps;
        }
        var items = Array.isArray(inject) ? inject : [
            inject
        ];
        items.forEach(function(param) {
            var attr = param.attr, selector = param.selector, format = param.format;
            var iAttr = Array.isArray(attr) ? attr : [
                attr || key
            ];
            var iSelector = Array.isArray(selector) ? selector.join(', ') : selector;
            var iFormat = typeof format === 'function' ? format : function(i) {
                return i.toString();
            };
            if (format === 'px') {
                iFormat = _gemsShared.pxWithAuto;
            } else if (format === 'percent') {
                iFormat = _gemsShared.percent;
            }
            maps.push({
                key: key,
                attr: iAttr,
                selector: iSelector,
                format: iFormat
            });
        });
        return maps;
    }, []);
}
var getInjectSchema = (0, _gemsShared.withMemo)(iGetInjectSchema);
function formatInjectStyles(scope, style, schema) {
    return getInjectSchema(schema).reduce(function(accu, param) {
        var key = param.key, attr = param.attr, selector = param.selector, format = param.format;
        var v = style[key];
        if (!v) {
            return accu;
        }
        var value = format(v);
        accu.push("\t#".concat(scope, " ").concat(selector, " { ").concat(attr.map(function(i) {
            return "".concat(i, ": ").concat(value);
        }).join('; '), " }"));
        return accu;
    }, []).join('\n');
} // 用于处理 Schema 中的样式注入，详见：https://vision.oa.com/docs/dev-style-inject/#示例
function StyleInjectHandler(param) {
    var _instance = param.instance, key = _instance.key, _component = _instance.component, styleForm = _component.styleForm, injectStyle = _component.injectStyle, style1 = _instance.style, scope = param.scope, children = param.children;
    var cssProps = (0, _react.useMemo)(function() {
        return injectStyle ? formatInjectStyles(scope, style1, styleForm) : null;
    }, [
        style1
    ]);
    var entry = (0, _react.useMemo)(function() {
        if (!injectStyle) {
            return;
        }
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.setAttribute('class', "injected-styles-component-".concat(key));
        window.__iframeWindow.document.head.appendChild(style);
        return style;
    }, [
        key
    ]);
    (0, _react.useEffect)(function() {
        if (!injectStyle) {
            return;
        }
        entry.innerHTML = cssProps;
        window.__iframeWindow.document.head.appendChild(entry);
        return function() {
            window.__iframeWindow.document.head.removeChild(entry);
        };
    }, [
        cssProps,
        entry
    ]);
    return children;
}
